var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.LaborDocument,{attrs:{"variant":"dialog","laborList":_setup.laborList}})
}
var staticRenderFns = []

export { render, staticRenderFns }